/** Matches backend Document.STATUS_CHOICES. */

export const DOCUMENT_STATUS_CHOICES = [
  { value: "SENT_TO_ATHENS", label: "Sent To Athens" },
  { value: "RECEIVED_IN_ATHENS", label: "Received In Athens" },
  { value: "SENT_TO_TORONTO", label: "Sent To Toronto" },
  { value: "RECEIVED_IN_TORONTO", label: "Received In Toronto" },
  { value: "SENT_TO_MONTREAL", label: "Sent To Montreal" },
  { value: "RECEIVED_IN_MONTREAL", label: "Received In Montreal" },
  { value: "SENT_TO_CLIENT", label: "Sent To Client" },
  { value: "RECEIVED_FROM_CLIENT", label: "Received From Client" },
];

export function documentStatusLabel(status) {
  if (status == null || String(status).trim() === "") return "";
  const found = DOCUMENT_STATUS_CHOICES.find((c) => c.value === status);
  return found ? found.label : String(status);
}

export const DOCUMENT_STATUS_SELECT_FILTER_OPTIONS = DOCUMENT_STATUS_CHOICES.reduce(
  (acc, c) => {
    acc[c.value] = c.label;
    return acc;
  },
  { "": "All" }
);
